import { SortOrder } from '../../../../shared/table/types';

export enum AdminAIChatbotActionTypes {
    FETCH_CUSTOM_QUERY_ANALYTICS_STARTED = 'FETCH_CUSTOM_QUERY_ANALYTICS_STARTED',
    FETCH_CUSTOM_QUERY_ANALYTICS_SUCCESSFUL = 'FETCH_CUSTOM_QUERY_ANALYTICS_SUCCESSFUL',
    FETCH_CUSTOM_QUERY_ANALYTICS_FAILED = 'FETCH_CUSTOM_QUERY_ANALYTICS_FAILED'
}

export enum ChatBotAnalyticsPieCharts {
    TOTAL = 'total-questions-pie-chart',
    DOCUMENT = 'document-questions-pie-chart',
    CLIENT_OR_USER = 'client-or-user-questions-pie-chart'
}

export enum PreviousQuestionsTab {
    CORRECT = 'Correct Queries',
    INCORRECT = 'Incorrect Queries'
}

export interface DocumentNameQuestionsTotal {
    [documentName: string]: number;
}

export interface BreakdownQuestionData {
    [name: string]: { totalAsked: number, totalPassed: number, id: number };
}

export interface QuestionsAskedByUser {
    questionAsked: string;
    acceptedByCheck: number;
    dateAsked: string;
}

export interface CustomDocumentQueryAnalytics {
    totalQuestionsAsked: number;
    totalQuestionsPassed: number;
    questionsAskedPerDocumentNameType: DocumentNameQuestionsTotal;
    questionsAskedPerClient?: BreakdownQuestionData;
    questionsAskedPerClientUser?: BreakdownQuestionData;
    questionsAskedByUser?: QuestionsAskedByUser[];
}

export interface BreakdownColumnSort {
    [column: string]: SortOrder | null;
}

export interface BreakdownList {
    name: string;
    totalAsked: number;
    totalPassed: number;
    id: number;
}

export interface SelectedClientOrUser {
    id: number;
    name: string;
}

export interface AdminAIChatbotState {
    isFetchingCustomQueryAnalytics: boolean;
    customDocumentQueryAnalytics: CustomDocumentQueryAnalytics;
}
